import React from 'react';
import PropTypes from 'prop-types';

import {Typography, Grid, Box, ButtonLink, Stack} from 'views/components';
import {Translate, translate} from 'views/module';
import {TicketLogo, PagerLogo, RunbookLogo, PulseLogo, AlarmLogo} from 'views/icons';

import SignupBottom from './SignupBottom';

const Item = (props) => {
  const Icon = props.icon;
  const title = props.title;
  const body = props.body;
  const action = props.action;
  const link = props.link;
  const highlighted = props.highlighted;

  return (
    <Box
      sx={{
        py: '24px',
        px: '12px',
        backgroundColor: highlighted ? 'primary.light': 'transparent',
        borderRadius: '8px',
        height: '212px',
        display: 'grid',
      }}
    >
      <Stack direction={'row'}>
        <Icon
          sx={{
            height: '48px',
            width: '48px',
            mr: '16px',
          }}
        />
        <Box>
          <Typography
            variant='h6'
          >
            {title}
          </Typography>
          <Typography
            variant='footer'
            sx={{
              display: 'block',
            }}
          >
            {body}
          </Typography>
        </Box>
      </Stack>
      <Box
        sx={{
          width: '100%',
          textAlign: 'center',
          mt: 'auto',
          mb: '8px',
        }}
      >
        <ButtonLink
          variant='outlined'
          color='primary'
          to={link}
          sx={{
            'py': '8px',
            'px': '24px',
            'borderRadius': '100px',
            'borderWidth': '2px',
            'width': {md: '180px', xs: '140px'},

            '&:hover': {
              'borderWidth': '2px',
            },
          }}
        >
          <Typography
            variant='body2'
            sx={{
              fontWeight: 700,
              fontSize: {md: '1rem', xs: '0.75rem'},
            }}
          >
            {action}
          </Typography>
        </ButtonLink>
      </Box>
    </Box>
  );
};
Item.propTypes = {
  icon: PropTypes.any,
  title: PropTypes.any,
  body: PropTypes.any,
  action: PropTypes.any,
  link: PropTypes.any,
  highlighted: PropTypes.any,
};

const MAP = {
  TICKETING: {
    icon: TicketLogo,
    title: 'generic.DiscoverProduct.Ticketing.Title',
    body: 'generic.DiscoverProduct.Ticketing.Body',
    link: '/product/ticketing/',
  },
  PAGER: {
    icon: PagerLogo,
    title: 'generic.DiscoverProduct.Pager.Title',
    body: 'generic.DiscoverProduct.Pager.Body',
    link: '/product/pager/',
  },
  RUNBOOK: {
    icon: RunbookLogo,
    title: 'generic.DiscoverProduct.Runbook.Title',
    body: 'generic.DiscoverProduct.Runbook.Body',
    link: '/product/runbook/',
  },
  PULSE: {
    icon: PulseLogo,
    title: 'generic.DiscoverProduct.Pulse.Title',
    body: 'generic.DiscoverProduct.Pulse.Body',
    link: '/product/pulse/',
  },
  ALARM: {
    icon: AlarmLogo,
    title: 'generic.DiscoverProduct.Alarm.Title',
    body: 'generic.DiscoverProduct.Alarm.Body',
    link: '/product/alarm/',
  },
};

const NextStep = (props) => {
  const previous = props.previous;
  const next = props.next;

  const previousData = MAP[previous];
  const nextData = MAP[next];

  if (!previousData || !nextData) {
    return;
  }

  return (
    <Box>
      <Stack
        sx={{
          maxWidth: '100vw',
          margin: 'auto',
          backgroundColor: 'background.main',
          pt: {md: '40px', xs: '40px'},
        }}
      >
        <Box>
          <Typography
            variant='h4'
            sx={{
              textAlign: 'center',
            }}
          >
            <Translate expression='generic.DiscoverHow'/>
          </Typography>
        </Box>
        <Box
          sx={{
            mx: 'auto',
            mt: {md: '60px', xs: '20px'},
          }}
        >
          <Grid container spacing={{md: 10, xs: 0}}>
            <Grid item xs={6}>
              <Item
                icon={previousData.icon}
                title={translate(previousData.title)}
                body={translate(previousData.body)}
                action={translate('generic.DiscoverProduct.Action.Previous')}
                link={previousData.link}
                highlighted={false}
              />
            </Grid>
            <Grid item xs={6}>
              <Item
                icon={nextData.icon}
                title={translate(nextData.title)}
                body={translate(nextData.body)}
                action={translate('generic.DiscoverProduct.Action.Next')}
                link={nextData.link}
                highlighted={true}
              />
            </Grid>
          </Grid>
        </Box>
        <Box
          sx={{
            maxWidth: '100vw',
            margin: 'auto',
            backgroundColor: 'background.main',
            pb: {md: '40px', xs: '20px'},
            pt: {md: '20px', xs: '20px'},
          }}
        >
          <SignupBottom />
        </Box>
      </Stack>
    </Box>
  );
};
NextStep.propTypes = {
  previous: PropTypes.any,
  next: PropTypes.any,
};

export default NextStep;
